import { ISimpleTime } from "../../models"

export enum EBreakType {
  TimeWindow,
  TimeDuration
}

export interface IBreak {
  Id: string
  Name: string
  // if Break is Shift break, Type should be TimeWindow.
  // if Type is TimeWindow, should use the BreakWindowStartTime,  BreakWindowEndTime, BreakWindowStartDateTime and BreakWindowEndDateTime
  // if Type is TimeDuration, should use DurationToTrigger
  Type: EBreakType
  BreakWindowStartTime: ISimpleTime
  BreakWindowEndTime: ISimpleTime
  BreakWindowStartDateTime?: Date | string
  BreakWindowEndDateTime?: Date | string
  DurationToTrigger: number
  MinimumBreakDuration: number
  MaximumBreakDuration: number
  RecommendedBreakDuration: number
  RequirePunchBiometrics: boolean
  Deleted?: boolean
  PayTypeId: string
  Used?: boolean
  DisLocEx: boolean
  DisBioEx: boolean
  AllowMinBreakOverride: boolean
  OverrideMinBreakDuration: number
  AlternatePayTypeId: string
}